import { render, staticRenderFns } from "./RelbaseSettings.vue?vue&type=template&id=66351516&"
import script from "./RelbaseSettings.vue?vue&type=script&lang=js&"
export * from "./RelbaseSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports